module.exports = __webpack_public_path__ + "img/zgyzyh.16600879.png";